










import { Component, Vue, Prop } from "vue-property-decorator";
import { NewComerGiftPackRuleConfig } from "./model/newComerGiftPackRuleConfig";
import CouponSelect from "@/components/coupon-select/index.vue";
import CouponTable from "../couponTable/index.vue";
import CouponDto from "../coupon/model/couponDto";
@Component({
  components: {
    CouponSelect,
    CouponTable
  }
})
export default class NewComerGiftPack extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        memberScope: "All",
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: [],
        coupons: []
      };
    }
  })
  value!: NewComerGiftPackRuleConfig;

  couponSelectChange(list) {
    console.log(list);
    this.value.coupons = this.value.coupons.concat(
      list.map(x => {
        let item = {
          id: x.id,
          name: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.value
        };
        return item;
      })
    );
  }
}
